var $db3723c51a085311$exports = {};
$db3723c51a085311$exports = {
    "backButton": (args)=>`Volver a ${args.prevMenuButton}`,
    "moreActions": `M\xe1s acciones`,
    "unavailable": `No disponible, ampliar para m\xe1s detalles`
};


export {$db3723c51a085311$exports as default};
//# sourceMappingURL=es-ES.module.js.map
